













import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ElapsedTime extends Vue {
  @Prop() id!: string;
  @Prop() elapsedSeconds!: number;

  get displayValue() {
    const seconds = Math.floor(this.elapsedSeconds % 60);
    const minutes = Math.floor((this.elapsedSeconds / 60) % 60);
    const displaySeconds = (seconds < 10 ? `0${seconds}` : `${seconds}`);
    return `${minutes}:${displaySeconds}`;
  }
}
